const parseFilterDataMapping = {
    transaction_date: ['transaction_date:gte', 'transaction_date:lte']
}
  
export default parseFilterDataMapping
  